export const LANDING_URL = 'https://adoptic.io';

// Every Adoptic logo links back to the adoptic.io homepage.
export function BrandLogo({ className = 'h-[18px] w-auto brightness-0', testId = 'brand-logo', wrapperClassName = 'inline-flex items-center shrink-0' }) {
  return (
    <a href={LANDING_URL} className={wrapperClassName} aria-label="Adoptic homepage" data-testid={testId}>
      <img src="/adoptic-logo.png" alt="Adoptic" className={className} />
    </a>
  );
}
